/**
 * @module app.query.state
 */

class Service {
  /**
   * @ngInject
   */
  constructor($rootScope) {
    /**
     * @private
     */
    this.rootScope_ = $rootScope;

    /**
     * @private
     * @const {Set<string>}
     */
    this.queryBlockers_ = new Set();
  }

  /**
   * @export
   * @param {string} blocker
   */
  addQueryBlocker(blocker) {
    this.queryBlockers_.add(blocker);
    this.rootScope_.$broadcast('disableQuerying');
  }

  /**
   * @export
   * @param {string} blocker
   */
  removeQueryBlocker(blocker) {
    this.queryBlockers_.delete(blocker);
  }

  /**
   * @export
   * @return {boolean}
   */
  isQueryEnabled() {
    return this.queryBlockers_.size === 0;
  }
}

export default angular.module("appQueryState", []).service("appQueryStateService", Service);
